import z from "zod";

export const ENV_SCHEMA = z.object({
  VITE_CLIENT_ID: z.string().uuid(),
  VITE_CKO_PK: z.string(),
  VITE_DEV_USER_ID: z
    .string()
    .uuid()
    .optional()
    .or(z.literal("").transform(() => undefined)),
  VITE_ROUTE_SERVER: z
    .string()
    .url()
    .transform((v) => new URL(v).origin),
});

export const env = ENV_SCHEMA.parse(import.meta.env);
